import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../../utils/with-router-props'
import { callApi, fetchApiDataIfNeeded } from '../../../../actions/api'
import SHSForm from '../../../utils/shs-form'
import VerifyPassword from '../../../shared/forms/verify-password'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'
import EditableDisplayField from '../../../utils/editable-display-field'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import AccountSidebar from '../../../shared/account-sidebar'

const mapStateToProps = (state, ownProps) => {
    const account = state.adminAccounts.find(acc => acc.id === Number(ownProps.params.accountId))
    return {
        roles: state.roles,
        targetUser: state.adminUser.find(u => u.id === Number(ownProps.params.userId)),
        account,
        forms: state.forms
    }
}

const AdminUsersView = ({ dispatch, params, navigate, targetUser, roles, account, forms }) => {
    const userId = params.userId
    const accountId = params.accountId
    const [inEdit, setInEdit] = useState(false)
    const [allValid, setAllValid] = useState(false)

    const handleValidationChange = (isValid) => {
        setAllValid(isValid)
    }

    useEffect(() => {
        if (userId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/users', 'VIEW', userId)))
        }
    }, [dispatch, userId])

    useEffect(() => {
        if (accountId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'VIEW', accountId)))
        }
    }, [dispatch, accountId])

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('roles', 'LIST')))
    }, [dispatch])

    if (!targetUser) {
        return null
    }

    const roleOptions = roles.slice()
        .sort((a, b) => {
            if (a.level > b.level) {
                return -1
            }
            return 1
        })
        .map(role => ({ value: role.id, label: role.name }))

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            dispatch(callApi(apiResourceEndpoint('admin/users', 'DELETE', userId), {}, -1))
                .then((response) => {
                    if (response === 'SUCCESS') {
                        navigate(buildRoutePath(routes.adminUsersIndex.path, { accountId }))
                    } else {
                        window.alert('Unable to delete user. Please try again.')
                    }
                })
        }
    }

    const successFX = () => {
        setInEdit(false)
        window.alert('Password updated successfully!')
    }

    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('admin/users', 'UPDATE', targetUser.id, 'password'), formData, formId))
    }

    const renderPasswordForm = () => {
        return (
            <SHSForm submitFX={submitFX} successFX={successFX} buttonLabel="Update Password" buttonDisabled={!allValid} showCancel={true} cancelAction={() => setInEdit(false)}>
                <VerifyPassword onValidationChange={handleValidationChange} />
            </SHSForm>
        )
    }

    const renderPasswordView = () => {
        return (
            <>
                <span className="btn blue" onClick={() => setInEdit(true)}>Change Password</span>
            </>
        )
    }

    const renderPasswordChange = () => {
        return (
            <div className="manage-auth flex-100">
                {inEdit ? renderPasswordForm() : renderPasswordView()}
            </div>
        )
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>{targetUser.firstName} {targetUser.lastName}'s Info</h1>
                        <p>Manage the user fields below</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sidebar-layout">
                    <div className="sidebar box">
                        <AccountSidebar account={account} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <div className="main-content box">
                            <EditableDisplayField
                                label="First Name"
                                display={targetUser.firstName}
                                extraClass="flex-50"
                                endpoint="admin/users"
                                dataObj={targetUser}
                                fields={[{
                                    field: 'firstName',
                                    type: 'text',
                                    required: true
                                }]} />
                            <EditableDisplayField
                                label="Last Name"
                                display={targetUser.lastName}
                                extraClass="flex-50"
                                endpoint="admin/users"
                                dataObj={targetUser}
                                fields={[{
                                    field: 'lastName',
                                    type: 'text',
                                    required: true
                                }]} />
                            <EditableDisplayField
                                label="Email"
                                display={targetUser.email}
                                extraClass="flex-33"
                                endpoint="admin/users"
                                dataObj={targetUser}
                                fields={[{
                                    field: 'email',
                                    type: 'text',
                                    required: true
                                }]} />
                            <EditableDisplayField
                                label="Phone"
                                extraClass="flex-33"
                                display={targetUser.phone}
                                endpoint="admin/users"
                                dataObj={targetUser}
                                fields={[{
                                    field: 'phone',
                                    type: 'text',
                                    required: true
                                }]} />
                            <div className="label-values flex-33">
                                <span className="label">Account</span>
                                <p className="values">{targetUser._computed.accountTypeName}</p>
                            </div>
                            <EditableDisplayField
                                label="Role"
                                display={targetUser._computed.roleName}
                                extraClass="flex-33"
                                endpoint="admin/users"
                                dataObj={targetUser}
                                fields={[{
                                    field: 'roleId',
                                    type: 'valueSelect',
                                    options: roleOptions,
                                    required: true
                                }]} />
                            <p className="clickable" style={{ marginLeft: '50rem' }} onClick={handleDelete}>
                                <FontAwesomeIcon icon="trash-alt" /> DELETE USER
                            </p>
                        </div>
                        <div className="main-content box" style={{ marginTop: '2rem' }}>
                            { targetUser.createdAt ?
                                <>
                                    <h3>Auth Details</h3>
                                    <p>
                                        <span className="p-label">Created At</span><br />
                                        {moment(targetUser.createdAt).format('ddd. MMM. Do Y, hh:mm a')}<br />
                                        <span className="sm-txt">{moment(targetUser.createdAt).fromNow()}</span>
                                    </p>
                                    <p>
                                        <span className="p-label">Last Updated</span><br />
                                        {targetUser.updatedAt ? moment(targetUser.updatedAt).format('ddd. MMM. Do Y, hh:mm a') : 'N/A'}<br />
                                        {targetUser.updatedAt && <span className="sm-txt">{moment(targetUser.updatedAt).fromNow()}</span>}
                                    </p>
                                </>
                                : <p>User has never logged in</p>
                            }
                            { renderPasswordChange() }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminUsersView))
